// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-bootstrap-table-page-btns-ul{float:right;margin-top:0!important}.react-bootstrap-table-pagination-list-hidden{display:none}", ""]);
// Exports
module.exports = exports;
